import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { useDashboardFilterValues } from 'src/Utils/dashboards/dashboards.hooks'
import { FilterName, FilterParam } from '../../../FilterBar.types'
import { FilterDropdown } from '../../FilterDropdown'

export const DashboardDimensionFilterDropdown = ({
  isNested = false,
  filterParam,
  filterName,
  dashboardContext,
  dashboardName,
  dimension,
  undefinedString,
}: {
  isNested?: boolean
  filterParam: FilterParam
  filterName: FilterName
  dashboardContext: DASHBOARD_CONTEXT
  dashboardName: string
  dimension: string
  undefinedString?: string
}): JSX.Element => {
  const { data } = useDashboardFilterValues(
    dashboardContext,
    dashboardName,
    dimension,
  )
  const anonymousValue = undefinedString
    ? {
        label: undefinedString,
        value: '',
      }
    : undefined
  const filterValues = [
    ...(anonymousValue ? [anonymousValue] : []),
    ...(data
      ?.getFilterValuesList()
      .filter((filterString) => filterString !== '')
      .sort((a, b) => a.localeCompare(b))
      .map((filterString) => ({
        label: filterString,
        value: filterString,
      })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={filterParam}
      filterName={filterName}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
